import { ReactNode, FC } from "react";

import Button from "../../components/Desktop/Button";

type PageSectionProps = {
  heading: ReactNode;
  description: ReactNode;
  pageSectionVariant: "primary" | "secondary";
  button: {
    label: string;
    variant: "primary" | "secondary";
    onClick: () => void;
  };
  image: string;
}

const PageSection: FC<PageSectionProps> = ({ heading, description, pageSectionVariant, button, image }) => {
  if (pageSectionVariant === "primary") {
    return (
      <section className="px-[120px] py-[100px] bg-[#F8F8F8]">
        <div className="flex items-center justify-center gap-[64px]">
          {/* Image */}
          <div>
            <img src={image} alt="sectionImg" className="w-[750px] h-auto object-cover" />
          </div>

          {/* Text */}
          <div>
            <h3 className="text-[36px] font-raleway font-bold leading-tight text-primaryDark-0 mb-[16px]">{heading}</h3>
            <p className="text-[16px] font-open-sans mb-[16px] leading-loose max-w-[600px]">{description}</p>
            <Button label={button.label} variant="secondary" onClick={button.onClick} />
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className="px-[120px] py-[100px]">
      <div className="flex items-center justify-center gap-[64px]">
        {/* Text */}
        <div>
          <h3 className="text-[36px] font-raleway font-bold leading-tight text-primaryDark-0 mb-[16px]">
            {heading}
          </h3>
          <p className="text-[16px] font-open-sans mb-[16px] leading-loose max-w-[600px]">
            {description}
          </p>
          <Button
            label={button.label}
            variant="secondary"
            onClick={button.onClick}
          />
        </div>

        {/* Image */}
        <div>
          <img
            src={image}
            alt="sectionImg"
            className="w-[730px] h-auto object-cover"
          />
        </div>
      </div>
    </section>
  );
}

export default PageSection;